import React from "react";
import PropTypes from "prop-types";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const BillingDocumentSendingTableRow = ({ row }) => (
  <TableRow>
    <TableCell />
    <TableCell align="left">{row.id}</TableCell>
  </TableRow>
);
BillingDocumentSendingTableRow.propTypes = {
  row: PropTypes.object.isRequired,
};

export default BillingDocumentSendingTableRow;
